import React from 'react'

const LoadingDots = ({ loading, text, style }) => (
  loading ?
    <div className="loadingDots" style={style}>
      <div className="dots">
        <div className="dot"></div>
        <div className="dot"></div>
        <div className="dot"></div>
        <div className="dot"></div>
        <div className="dot"></div>
      </div>
      <strong>لطفا چند لحظه صبر کنید</strong>
      <p>{text}</p>
    </div>
    :
    ''
);

export default LoadingDots;